

























import { computed, defineComponent, getCurrentInstance, ref, watch } from "@vue/composition-api";
import { throttle } from "lodash-es";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import providers from "@/lib/providers";
import BaseAvatar from "@/components/BaseAvatar/BaseAvatar.vue";

export default defineComponent({
  name: "UserAutocomplete",
  components: { BaseAvatar },
  props: {
    label: { type: String },
    placeholder: { type: String },
    value: { type: Object as () => User },
    role: { type: String, default: null },
  },
  setup(props) {
    const vm = getCurrentInstance();
    const loadingUsers = ref(false);
    const searchInput = ref("");
    const userList = ref<User[]>([]);
    const dataList = computed(() => {
      let list = userList.value;
      if (userList.value.length === 0 && !!props.value) {
        list = [props.value];
      }
      return list.map(userItem => ({
        text: userItem.screenName,
        value: userItem,
      }));
    });
    const hideNoData = computed(() => loadingUsers.value || userList.value.length === 0);
    const getUsers = throttle(
      async search => {
        try {
          loadingUsers.value = true;

          const searchResult = await providers.UserProvider.search({
            data: { term: search, sort: "SCREEN_NAME,ASC", role: props.role },
          });
          if (searchResult) {
            userList.value = searchResult.result.filter((userItem: User) => userItem.id !== (vm?.$route.params.userId || ""));
          }
        } finally {
          loadingUsers.value = false;
        }
      },
      1000,
      { leading: false, trailing: true }
    );

    watch(searchInput, newVal => {
      getUsers(newVal);
    });

    const filter = ({ value: user }: { value: User }, queryText: string, itemText: string) => {
      return (
        user &&
        (user.id === queryText ||
          user.screenName?.startsWith(queryText) ||
          user.email?.startsWith(queryText) ||
          user.accountInfo.lastLoginIp === queryText ||
          user.accountInfo.registrationIp === queryText ||
          user.screenName === itemText)
      );
    };
    return {
      dataList,
      filter,
      loadingUsers,
      hideNoData,
      searchInput,
    };
  },
});
